const OrderDetailDelivery = class {
  constructor({ address, roadAddress, mobileNumber, userEmail, safeMobileNumber, deliveryTip, memo }) {
    this.address = address
    this.roadAddress = roadAddress
    this.mobileNumber = mobileNumber
    this.safeMobileNumber = safeMobileNumber
    this.deliveryTip = deliveryTip
    this.memo = memo
    this.userEmail = userEmail
  }
}

export default null

export const ofOrderDetailDelivery = (params = {}) => new OrderDetailDelivery(params)
